<template>
  <div class="flex flex-col bg-white px-2">
    <div class="flex flex-col gap-[5px] pt-3 mt-3">
      <db-form class="flex flex-col gap-[5px]">
        <p class="flex justify-center mt-2 text-sm'">
          {{ $t("landing.reset_password.reset_info") }}
        </p>
        <db-input
          variant="outline"
          :placeholder="$t('login.username') + '*'"
          :label="$t('login.username') + '*'"
          name="username"
          :ariainvalid="errors.username ? 'true' : ''"
          v-model="user.username"
        ></db-input>
        <p
          :class="
            errors.username == true && errors.password == true
              ? 'flex text-red-700 justify-center mt-2 text-sm'
              : 'hidden'
          "
        >
          {{ $t("login.error") }}
        </p>
        <db-button
          id="login"
          variant="brand-primary"
          class-list="w-full mt-2"
          @click="reset"
        >
          {{ $t("landing.reset_password.submit") }}
        </db-button>
      </db-form>
      <router-link class="w-full" to="/login">
        <db-button variant="tertiary-plain" class-list="w-full">
          {{ $t("landing.reset_password.cancel") }}
        </db-button>
      </router-link>
      <div class="flex w-full pt-16">
        <p class="text-sm text-gray-400">
          {{ $t("landing.required_field") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import store from "@/store";
import firebaseAuthService from "@/services/FirebaseAuthService";
import DbInput from "@/components/DB-Components/DbInput.vue";
import DbButton from "@/components/DB-Components/DbButton.vue";

export default defineComponent({
  components: { DbInput, DbButton },
  name: "LoginComponent",

  setup() {
    const router = useRouter();
    const title = process.env.NODE_ENV;
    const user = ref({
      username: "",
    });

    const errors = ref({
      username: false,
    });

    const resetErrors = () => {
      errors.value = {
        username: false,
      };
    };

    const reset = async () => {
      await store.dispatch("toggleLoading", true);
      resetErrors();

      await store
        .dispatch("UserStore/resetPassword", user.value)
        .then(async (res) => {
          const { confirmationResult } =
            await firebaseAuthService.resetPasswordWithPhoneNumber(
              res.data.phone_number,
              window.recaptchaVerifier
            );
          window.confirmationResult = confirmationResult;

          await store.dispatch("UserStore/setUser", res.data);
          router.push("/code");
        })
        .catch(async (error) => {
          errors.value = {
            username: true,
          };
          router.push("/code");
        });
      await store.dispatch("toggleLoading", false);
    };

    return {
      user,
      reset,
      title,
      errors,
    };
  },
});
</script>
